import { useEffect, useState } from 'react'
import { i18n } from '@fs/zion-locale'
import axios from '@fs/zion-axios'
import { appPath } from '@fs/zion-config'
import { type ReportsIndex } from '../types'

type UsePlaceReportsIndexResult = {
  reportsIndex: ReportsIndex
  setReportsIndex: (index: ReportsIndex) => void
  error: Error | null
}

export default function usePlaceReportsIndex(): UsePlaceReportsIndexResult {
  const [reportsIndex, setReportsIndex] = useState<ReportsIndex>({ regions: [] })
  const [error, setError] = useState<Error | null>(null)
  const locale = i18n.language

  useEffect(() => {
    async function fetchDirectoryContent() {
      try {
        const response = await axios.get<ReportsIndex>(`${appPath}/place-reports/directory-content/`)
        setReportsIndex(response.data)
      } catch (err) {
        console.error('Error fetching markdownFiles content:', err)
        setError(err as Error)
      }
    }

    fetchDirectoryContent()
  }, [locale])

  return { reportsIndex, setReportsIndex, error }
}
